import { IFilter } from "@/models/tables";
import { FilterTypes, FilterOperators } from "@/data/table";
import i18n from "@/i18n";

const configurationsFilters: IFilter[] = [
  {
    key: "name",
    label: i18n.t("_.name"),

    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS
  },
  {
    key: "enabled",
    label: i18n.t("_.status"),

    type: FilterTypes.SELECT_RADIO,
    options: [
      { value: true, label: i18n.t("_.enabled").toString() },
      {
        value: false,
        label: i18n.t("_.disabled").toString()
      }
    ],
    operator: FilterOperators.EQUAL
  },
  {
    key: "category.code",
    label: i18n.t("_.category"),

    type: FilterTypes.SELECT,
    options: [],
    operator: FilterOperators.EQUAL
  },
  {
    key: "provider.name",
    label: i18n.t("_.provider"),

    type: FilterTypes.SELECT,
    options: [],
    operator: FilterOperators.EQUAL
  }
];

const categoriesFilters: IFilter[] = [
  {
    key: "name",
    label: i18n.t("_.name"),

    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS
  }
];

export { configurationsFilters, categoriesFilters };
